<template>
  <v-dialog
    v-model="modal"
    max-width="750"
    :persistent="persistent">
    <template v-slot:default="dialog">
      <v-card
        class="rounded-lg">
        <v-toolbar
          width="100%"
          :color="color ? color : 'primary'"
          height="79"
          style="position: relative;">
          <v-row
            class="text-center d-flex justify-center">
            <span
              class="text-h5 foreground-accent--text font-weight-bold">
              {{ title }}
            </span>
            <v-btn
              icon
              class="elevation-4"
              :color="color ? color : 'primary'"
              heiht="43"
              max-height="43"
              width="43"
              v-if="showCloseButton"
              style="position: absolute; right: 5%; top: 20%;"
              @click="close">
              <v-icon
                size="30"
                color="foreground-accent">
                close
              </v-icon>
            </v-btn>
          </v-row>
        </v-toolbar>
        <v-card-text
          class="mt-1 pb-0"
          style="min-height: 100px;">
          <v-container
            fuild
            class="fill-height pb-0">
            <v-row>
              <v-col
                cols="12"
                class="text-center">
                <span
                  class="text-h6 foreground--text font-weight-regular" v-html="description">
                </span>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions
          class="px-13 pb-8 pt-7">
          <v-row>
            <v-spacer />
            <v-btn
              v-if="showCancelButton"
              height="50"
              width="150"
              color="muted-foreground"
              class="rounded-pill mr-6"
              @click="cancel">
              <v-icon
              :color="color ? color : 'primary'">
                mdi mdi-arrow-left
              </v-icon>
              <span
                :class="color ? 'foreground-accent--text  text-h6' : 'primary--text text-h6'">
                {{ cancelLabel }}
              </span>
            </v-btn>
            <v-btn
              height="50"
              width="260"
              :color="color ? color : 'primary'"
              class="rounded-pill"
              @click="confirm">
              <span
                class="foreground-accent--text text-h6">
                {{ confirmLabel }}
              </span>
            </v-btn>
          </v-row>
        </v-card-actions>
      </v-card>
    </template>
  </v-dialog>
</template>
<script>
export default {
  name: "ConfirmationModal",

  data: () => ({
    modal: false,
    dataId: null,
  }),

  props: {
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    confirmLabel: {
      type: String,
      default: 'Confirmar'
    },
    cancelLabel: {
      type: String,
      default: 'Voltar'
    },
    color: {
      type: String,
      default: ''
    },
    showCloseButton: {
      type: Boolean,
      default: true,
    },
    showCancelButton: {
      type: Boolean,
      default: true,
    },
    persistent: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    open(dataId) {
      this.modal = true;
      this.dataId = dataId;
    },
    close() {
      this.dataId = null;
      this.modal = false;
      this.$emit('close')
    },
    cancel() {
      this.dataId = null;
      this.modal = false;
      this.$emit('cancel')
    },
    confirm() {
      this.$emit('confirm', this.dataId)
      this.close();
		},
  },
}
</script>